module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAOVBMVEUAAAAqrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8FoIuQAAAAEnRSTlMAxPInrZAZCfgu2LaYNOTfOTZ1pcfkAAAAjUlEQVQ4y+2S2wrEIAxEvaUm1u5l/v9jlwW7K4xgC33seUqYAw4Y12NSVItENyZXNGoe5h4qr5zfovAjo+Jh7aUnKucGtX2OCiNBILz0FGz/ZUMhQZG7wggkALSdEGIKIEKKv7zFpOxGwro4YlmR2hjwzdlAoEbU+5Tg0eEPCneHqzpMv3t+MPOTmx/tBwfzE2k1rbWTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_lock.png
// module id = sD4i
// module chunks = 1